import * as Yup from 'yup';
import { validateAreaCode } from '../utils/validateAreaCode';

export const initialValues = {
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    location: '',
    description: '',
};

export const contactSchema = Yup.object().shape({
    first_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    last_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    email: Yup.string().email('Invalid email').required('Required'),
    phone: Yup.string()
        .min(15, 'Invalid phone number')
        .required('Required')
        .test('no-identical-area-code', 'Invalid phone number', validateAreaCode),
    location: Yup.string().required('Required'),
    description: Yup.string(),
});
